import { mapState, mapGetters, mapMutations } from 'vuex';

import EmptyList from '@/views/Events/components/EmptyList.vue';

export default {
  name: 'EventListInPanel',

  components: {
    EmptyList,
  },

  data() {
    return {};
  },

  computed: {
    ...mapState('Events', {
      ms_selectedCourseType: 'selectedCourseType',
      ms_selectedSubCourseType: 'selectedSubCourseType',
    }),

    ...mapGetters('Events', {
      mg_courseTypes: 'courseTypes',
      mg_subCourseTypes: 'subCourseTypes',
    }),
  },

  methods: {
    ...mapMutations('Events', {
      mm_SET_SELECTED_COURSE_TYPE: 'SET_SELECTED_COURSE_TYPE',
      mm_SET_SUB_SELECTED_COURSE_TYPE: 'SET_SUB_SELECTED_COURSE_TYPE',
    }),

    selectCourseType(courseType) {
      this.mm_SET_SELECTED_COURSE_TYPE(courseType);
      this.mm_SET_SUB_SELECTED_COURSE_TYPE('');
    },

    selectSubCourseType(subCourseType) {
      this.mm_SET_SUB_SELECTED_COURSE_TYPE(subCourseType);
    },
  },
};
